"use client";

import NextScript from "next/script.js";
import type { ScriptHTMLAttributes } from "react";

import { useNonce } from "../lib/security/use-nonce.js";

type ScriptProps = ScriptHTMLAttributes<HTMLScriptElement> & {
  readonly strategy?: "afterInteractive" | "lazyOnload" | "beforeInteractive";
};

const NextScriptComponent = NextScript.default;

export const Script = (props: ScriptProps) => {
  const nonce = useNonce();

  return (
    <NextScriptComponent nonce={nonce} {...props} suppressHydrationWarning />
  );
};
